import { useContext } from 'react';
import StatsContext, { IStatsContext } from 'dashboard/contexts/StatsContext';

const useStats = (): IStatsContext => useContext(StatsContext);

export default useStats;
